import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'biz-empty',
  templateUrl: 'empty.component.html',
  styleUrls: ['empty.component.css']
})
export class EmptyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
